import axios from "axios"

const apiUrl = process.env.REACT_APP_API_URL
export const api = axios.create({
    headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true
})
console.log("VaultApi loaded, interceptors registered");
let isRefreshing = false
let failedQueue = []

const processQueue = (error) => {
    failedQueue.forEach(({resolve,reject})=>{
        error ? reject(error) : resolve()
    })
    failedQueue = []
}

export const handleSession = () => {
    const userId = window.sessionStorage.getItem("USER_ID")
    const userName = window.sessionStorage.getItem("user_name")

  return {userId,userName};
}

api.interceptors.response.use(
    (response) => response,
    async(error)=>{
        const originalRequest = error.config
console.log("🚨 INTERCEPTOR TRIGGERED", error?.response?.status);

        // Refresh token itself failed → session truly expired
      if (originalRequest.url?.includes("/v1/vault/refresh-token")) {
        isRefreshing = false;
        processQueue(error);
        window.dispatchEvent(new CustomEvent("vault-session-expired"));
        console.log("vault-session-expired trigerred");
        
        return Promise.reject(error);
      }

        if(error?.response.status === 401 && !originalRequest._retry) {
            if(isRefreshing) {
                return new Promise((resolve,reject)=>{
                    failedQueue.push({resolve,reject})
                }).then(()=>api(originalRequest))
            }
        

        originalRequest._retry = true
        isRefreshing = true

        try {
            const user = handleSession()
            await api.get(`${apiUrl}/v1/vault/refresh-token/${user?.userId}/${user?.userName}`)
            processQueue(null)
            return api(originalRequest)
        } catch (refreshError) {
            processQueue(refreshError)
            return Promise.reject(refreshError)
        } finally {
            isRefreshing = false
        }
    }
    return Promise.reject(error)
}
)